<template>
  <label class="b-contain">
    <span>{{ label }}</span>
    <input type="radio" :name="name" :value="value" v-model="input" :disabled="disabled">
    <div class="b-input"></div>
  </label>
</template>

<script>
export default {
  props: ['value', 'checked', 'label', 'name', 'disabled'],
  model: {
    prop: 'checked',
    event: 'change'
  },
  computed: {
    input: {
      set (value) {
        this.$emit('change', value)
      },
      get () {
        return this.checked
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
